import SubmitSkeleton from "../SubmitSkeleton";
import { useCaseContext } from "../../../context/CaseContext";

const HasAbuserInfo = ({ setStep }: { setStep: (step: number) => void }) => {
  const { hasAbuserInfo, updateCaseData } = useCaseContext();

  return (
    <SubmitSkeleton
      title="Do you have any information on who commited the incident?"
      onPrev={() => setStep(5)}
      onNext={() => setStep(7)}
      progress={6 / 10}
    >
      <div className="flex flex-col">
        <label className="flex items-center gap-3 pr-6 pl-[13px] cursor-pointer">
          <input
            type="radio"
            name="subcase"
            value="yes"
            checked={hasAbuserInfo}
            onChange={() => updateCaseData("hasAbuserInfo", true)}
            className="form-radio"
          />
          <span className="font-medium text-base leading-4 text-black py-[14px]">
            Yes
          </span>
        </label>

        <label className="flex items-center gap-3 pr-6 pl-[13px] cursor-pointer">
          <input
            type="radio"
            name="subcase"
            value="no"
            checked={!hasAbuserInfo}
            onChange={() => updateCaseData("hasAbuserInfo", false)}
            className="form-radio"
          />
          <span className="font-medium text-base leading-4 text-black py-[14px]">
            No
          </span>
        </label>
      </div>
    </SubmitSkeleton>
  );
};

export default HasAbuserInfo;
